import {
  BrowserExtensionNotInstalledError,
  UserRejectedWalletConnectionRequestError,
} from '@errors';
import { WalletType } from '@types';
import { useState } from 'react';

type WindowWithEthereum = Window &
  typeof globalThis & {
    ethereum: any;
  };

interface useRegisterTokenParams {
  tokenAddress: string;
  symbol: string;
  decimals: number;
  logoURI: string;
}

function useRegisterToken({
  tokenAddress,
  symbol,
  decimals,
  logoURI,
}: useRegisterTokenParams) {
  const [error, setError] = useState<{ message: string }>();
  const registerToken = async () => {
    const win = window as WindowWithEthereum;
    if (typeof win === 'undefined' || !win.ethereum) {
      throw new BrowserExtensionNotInstalledError(WalletType.metamask);
    }

    try {
      await win.ethereum.request({
        method: 'wallet_watchAsset',
        params: {
          type: 'ERC20',
          options: {
            address: tokenAddress,
            symbol: symbol,
            decimals: decimals,
            image: logoURI,
          },
        },
      });
    } catch (error: any) {
      if (!tokenAddress) {
        setError({
          message: 'Failed to fetch token data, please add manually',
        });
      } else {
        setError({ message: 'Something went wrong, please add manually' });
      }
      if (error.code === 4001) {
        throw new UserRejectedWalletConnectionRequestError();
      }

      throw error;
    }
  };

  return {
    registerToken,
    error,
  };
}

export default useRegisterToken;
